export enum NewsItemLayoutType {
  Layout1 = 0,
  Layout2 = 1,
  Layout3 = 2,
  Layout4 = 3
}
